/**
 * Handles Cashfree payment initialization and checkout flow
 */

/**
 * Initialize and open Cashfree checkout
 * @param {string} paymentSessionId - Cashfree payment session ID
 * @returns {Promise} - Resolves with payment result or rejects with error
 */
export const openCashfreeCheckout = (paymentSessionId) => {
  return new Promise(async (resolve, reject) => {
    try {
      // Dynamically import Cashfree SDK
      const { load } = await import('@cashfreepayments/cashfree-js');
      
      // Load Cashfree SDK
      // TODO: Change mode to "production" in production environment
      const cashfree = await load({
        mode: process.env.REACT_APP_CASHFREE_MODE || "sandbox"
      });
      
      // Initialize checkout with modal target
      const checkoutOptions = {
        paymentSessionId: paymentSessionId,
        redirectTarget: "_modal", // Opens in modal within the same page
      };
      
      cashfree.checkout(checkoutOptions).then((result) => {
        if (result.error) {
          // User closed the modal or payment error occurred
          reject(new Error('Payment cancelled or failed'));
          return;
        }
        
        if (result.redirect) {
          // Payment will be redirected (exceptional case for inAppBrowser)
          console.log("Payment will be redirected");
          reject(new Error('Payment redirection required'));
          return;
        }
        
        if (result.paymentDetails) {
          // Payment completed (irrespective of transaction status)
          // Note: Actual payment status is verified via webhook
          resolve({
            paymentDetails: result.paymentDetails,
            order_id: result.paymentDetails?.order_id
          });
        } else {
          reject(new Error('Payment result incomplete'));
        }
      }).catch((error) => {
        console.error("Cashfree checkout error:", error);
        reject(error);
      });
    } catch (error) {
      console.error("Error loading Cashfree SDK:", error);
      reject(new Error('Failed to load payment gateway'));
    }
  });
};
